module.exports = __webpack_public_path__ + "d5e5f093c2debb056c9faeb96a53247a.svg";